import { configureStore } from '@reduxjs/toolkit'
import logger from 'redux-logger'
import { persistStore } from 'redux-persist'

import { api } from '@/services/base'
import reducer from '@/state/reducer'

export const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    })
      .concat(api.middleware)
      .concat(logger)
  },
  devTools: true,
})

export const persistor = persistStore(store)
